import i18n from 'i18n-js';
import {
  setScanPackPrompt,
  setScanPackPromptInput,
  closePrompt,
  getStateValues,
  addLocalLog,
  setScanPackLoadingState,
  resetPromptWithError
} from './scanpackScanningSetters';
import { AddOrderItems } from './orderActions';
import { handleReloadOrder } from './scanpackScanningActions';
import {
  checkConfirmationCodeForServiceIssue as checkConfirmationCodeApi,
  searchProductByBarcode
} from '../services/scanpackApiService';
import { saveLogToStorage } from '../utils/logStorageUtils';
import stampGuidedLog from '../components/ScanpackScanning/utils/boxChampGuidedLog';

const verifyConfirmationCode = async (dispatch, input) => {
  setScanPackLoadingState(dispatch, true);
  const res = await checkConfirmationCodeApi(input);
  setScanPackLoadingState(dispatch, false);
  return res.data.user?.confirmation_code === input && res.data.user?.role.add_edit_order_items;
};

const addProductToOrder = async (dispatch, getState, productId, sku) => {
  const { currentOrder, activeBoxIndex, userInfo } = getStateValues(getState);
  const currentBoxName = currentOrder?.boxes?.[activeBoxIndex]?.name || '';
  await dispatch(AddOrderItems(currentOrder?.id, {
    productids: [productId],
    qty: 1,
    on_ex: 'on GPX',
    is_allowed: true,
    add_to_scanned_list: true,
    box_name: currentBoxName
  }));

  const logData = {
    event: 'add_next',
    id: currentOrder?.id,
    name: userInfo?.name || '',
    time: new Date(),
    Log_count: '',
    SKU: sku
  };
  stampGuidedLog(logData, getState());
  await saveLogToStorage(logData);
  addLocalLog(dispatch, logData);

  dispatch(handleReloadOrder());
};

export function submitAddItem() {
  return async (dispatch, getState) => {
    const { prompt, userInfo } = getStateValues(getState);
    const input = prompt.input;
    if (!input) return;

    const isUserAllowed = userInfo?.role?.add_edit_order_items;
    const searchMsg = i18n.t('AddNextBarcode.search_item_msg');

    try {
      if (!isUserAllowed && prompt.message !== searchMsg) {
        const verified = await verifyConfirmationCode(dispatch, input);
        if (verified) {
          dispatch(setScanPackPrompt(true, searchMsg, 'add_item', '', false));
        } else {
          resetPromptWithError(dispatch, getState);
        }
        return;
      }

      setScanPackLoadingState(dispatch, true);
      const res = await searchProductByBarcode(input);
      const product = res.data[0];

      if (product?.id && product?.status === 'active') {
        await addProductToOrder(dispatch, getState, product.id, input);
        setScanPackLoadingState(dispatch, false);
        dispatch(closePrompt());
        return;
      }

      setScanPackLoadingState(dispatch, false);
      dispatch(setScanPackPromptInput(''));
      dispatch(setScanPackPrompt(true, prompt.message, 'add_item', '', i18n.t('order.addItemToOrderError')));
    } catch (e) {
      resetPromptWithError(dispatch, getState);
    }
  };
}
